/**
 * Mock 模块：heart_voyage_peak_rank
 * 默认海选：list 8 条（台座 3 + 行 5，含 1 条 self）；own 对齐当前 pair。
 * @see mockMd/heart_voyage_peak_rank.md
 */
import {storiesAvatar} from '../components/PeakRacePanel/stories-images'
import {
  RelationType,
  type HeartVoyagePeakRankData,
  type HeartVoyageRankPairItem,
} from '../types'

const MOCK_USER_AVATAR = storiesAvatar

const REL_CYCLE = [
  RelationType.Couple,
  RelationType.Confidant,
  RelationType.CloseFriend,
  RelationType.Brother,
  RelationType.Sister,
] as const

const MOCK_SCORE = 22500
const ROW_SCORES = [22500, 22500, 22500, 22500, 22500]

const mockPair = (rank: number): HeartVoyageRankPairItem => {
  const isSelf = rank === 4
  const idA = isSelf ? 10001 : 20000 + rank * 2
  const idB = isSelf ? 10002 : 20001 + rank * 2
  const score = rank <= 3 ? MOCK_SCORE : ROW_SCORES[rank - 4]
  return {
    rank,
    score,
    pair_key: `${idA}:${idB}`,
    ship_level: 12,
    ship_form: ((rank - 1) % 5) + 1,
    rel_type: REL_CYCLE[(rank - 1) % REL_CYCLE.length],
    member_a: {
      id: idA,
      name: 'Cance Aweel...',
      zy_id: String(idA),
      avatar: MOCK_USER_AVATAR,
      gender: 2,
    },
    member_b: {
      id: idB,
      name: 'Cance Aweel...',
      zy_id: String(idB),
      avatar: MOCK_USER_AVATAR,
      gender: 1,
    },
  }
}

const auditionList = Array.from({length: 8}, (_, i) => mockPair(i + 1))
const finalsList = Array.from({length: 8}, (_, i) => mockPair(i + 1))

/** 稿面 24:59:59 */
const MOCK_SEGMENT_COUNTDOWN_SEC = 24 * 3600 + 59 * 60 + 59

/** @see mockMd/heart_voyage_peak_rank.md · 默认海选 */
export const HeartVoyagePeakRankMock: HeartVoyagePeakRankData = {
  err_msg: '',
  segment: 1,
  group_id: 0,
  group_name: '',
  segment_countdown: MOCK_SEGMENT_COUNTDOWN_SEC,
  list: auditionList,
  own: auditionList[3],
  predict_group: {
    group_id: 2,
    group_name: 'Excellence Group',
  },
}

/** 决赛：无 predict_group；仍有 own 吸底 */
export const HeartVoyagePeakRankFinalsMock: HeartVoyagePeakRankData = {
  err_msg: '',
  segment: 2,
  group_id: 1,
  group_name: 'Pinnacle Group',
  segment_countdown: MOCK_SEGMENT_COUNTDOWN_SEC,
  list: finalsList,
  own: finalsList[3],
  predict_group: null,
}
